import { put, select, takeLatest } from 'redux-saga/effects';
import { CHAT_LOADERS, CHAT_ACTIONS } from './utils';

import {
  addMessageToChat,
  sendMessage,
  setChats,
  setCurrentChat,
  setLoader,
} from './reducer';

import { PayloadAction } from '@reduxjs/toolkit';
import { selectCurrentChatId, selectOtherUser } from './selectors';
import { OtherUser } from './model';
import { getChatMessages } from '@/api/requests/endpoints/GET/getChatMessages';
import { sendNewMessage } from '@/api/requests/endpoints/POST/sendNewMessage';
import { getChats } from '@/api/requests/endpoints/GET/getChats';

function* fetchMessagesSaga() {
  try {
    yield put(setLoader({ key: CHAT_LOADERS.FETCH_MESSAGES, value: true }));
    const response = yield getChats();

    yield put(setChats(response));
  } catch (e) {
    console.log(e);
  } finally {
    yield put(setLoader({ key: CHAT_LOADERS.FETCH_MESSAGES, value: false }));
  }
}

function* getChatByIdSaga({ payload }: PayloadAction<{ chatId: string }>) {
  try {
    yield put(setLoader({ key: CHAT_LOADERS.GET_CHAT_BY_ID, value: true }));

    const chat = yield getChatMessages(payload.chatId);

    const response = {
      chatId: payload.chatId,
      ...chat,
    };
    yield put(setCurrentChat(response));
  } catch (e) {
    console.log(e);
  } finally {
    yield put(setLoader({ key: CHAT_LOADERS.GET_CHAT_BY_ID, value: false }));
  }
}

function* sendMessageSaga({ payload }: ReturnType<typeof sendMessage>) {
  try {
    yield put(setLoader({ key: CHAT_LOADERS.SEND_MESSAGE, value: true }));

    const chatId: string = yield select(selectCurrentChatId);
    const otherUser: OtherUser = yield select(selectOtherUser);
    const response = yield sendNewMessage({
      chatId: chatId || payload.chatId,
      content: payload.message,
    });
    if (response) {
      const newMessage = {
        ...response,
        recipientId: otherUser.userId,
        content: payload.message,
      };

      yield put(addMessageToChat(newMessage));
    }
  } catch (e) {
    console.log(e);
  } finally {
    yield put(setLoader({ key: CHAT_LOADERS.SEND_MESSAGE, value: false }));
  }
}

export function* chatSaga() {
  yield takeLatest(CHAT_ACTIONS.FETCH_MESSAGES, fetchMessagesSaga);
  yield takeLatest(CHAT_ACTIONS.GET_CHAT_BY_ID, getChatByIdSaga);
  yield takeLatest(CHAT_ACTIONS.SEND_MESSAGE, sendMessageSaga);
}
